import styled from 'styled-components'

interface IButtonProps {
  isAvatar?: boolean
}

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const HeaderButton = styled.button<IButtonProps>`
  position: relative;

  box-shadow: 0 10px 11px 0 rgba(0, 0, 0, 0.15);
  width: 40px;
  height: 40px;
  background: ${({ theme }) => `rgb(${theme.background.low})`};
  border: none;
  padding: ${(props) => (props.isAvatar ? '0' : '0.5rem')};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50% !important;
  margin: 0 auto 0 0.5rem;

  svg {
    min-width: 25px;
    min-height: 25px;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
  }

  img,
  svg {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
  }

  .lifetimeBadge {
    position: absolute;

    top: 100%;
    left: 100%;

    transform: translate(-75%, -50%);

    width: 25px;
    height: 25px;

    background: rgba(5, 81, 117, 1);

    border-radius: 50%;
    border: 1.28px solid rgb(255, 255, 255);
    padding: 0.2rem;

    pointer-events: none;

    svg {
      display: block;

      min-width: unset;
      min-height: unset;

      width: 1rem;
      height: 1rem;

      color: rgb(255, 255, 255);
    }
  }
`

export const UserDropdown = styled.div`
  position: absolute;
  box-shadow: 0 13px 24px 0 rgba(0, 0, 0, 0.15);
  border-radius: 1rem;
  overflow: hidden;
  min-width: 17rem;
  z-index: 1100;
  background: ${({ theme }) => `rgb(${theme.background.low})`};

  top: 100%;
  left: 100%;
  transform: translate(-100%, 12px);

  ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    width: 100%;
    margin: 0;
  }

  li {
    margin: 0;
    padding: 1rem 2rem;
    font-size: 1rem;
    line-height: 1.25rem;
    font-weight: 700;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    display: flex;
    align-items: center;
    cursor: pointer;
    width: 100%;
    height: 100%;

    &:hover {
      background: ${({ theme }) => `rgb(${theme.primary[700]})`};
      color: rgba(74, 74, 74, 1);
    }

    svg {
      margin-right: 1rem;
    }
  }
  .selected {
    background-color: ${({ theme }) => `rgb(${theme.primary.base})`};
    color: ${({ theme }) => `rgb(${theme.background.low})`};
  }
`
interface SwitchDetailProps {
  isDarkMode: boolean
}

export const SwitchDetail = styled.div<SwitchDetailProps>`
  position: relative;

  width: 2.1875rem !important;
  height: 1rem !important;

  display: flex;
  justify-content: space-between;

  border-radius: 0.5rem;
  margin-left: auto;

  background: rgba(186, 186, 186, 1);

  pointer-events: none;

  .slider {
    position: absolute;
    top: 50%;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 1.5rem;
    height: 1.5rem;

    background: ${({ theme }) => `rgb(${theme.primary.base})`};

    border-radius: 50%;

    transition: all 0.3s;

    transform: ${({ isDarkMode }) => (isDarkMode ? 'translate(0, -50%)' : 'translate(50%, -50%)')};
  }

  svg {
    position: absolute;

    z-index: 1;

    margin: 0 !important;
    color: rgba(248, 248, 248, 1);

    display: ${({ isDarkMode }) => (isDarkMode ? 'none' : 'initial')};
  }

  svg:last-child {
    display: ${({ isDarkMode }) => (isDarkMode ? 'initial' : 'none')};
  }
`

export const QuestionDropdown = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 24px;
  box-shadow: 0 13px 24px 0 rgba(0, 0, 0, 0.15);
  border-radius: 1rem;
  padding: 1.5rem;
  min-width: 18rem;
  max-height: 20rem;
  z-index: 50;
  background: ${({ theme }) => `rgb(${theme.background.low})`};
  overflow: auto;

  top: 100%;
  left: 100%;
  transform: translate(-100%, 12px);

  ::-webkit-scrollbar {
    height: 0px;
    width: 4px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 15px;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .link {
    .date {
      font-weight: 600;
    }

    p {
      margin: 0;
      line-height: 1.25;
    }
  }
`

export const Badge = styled.div`
  position: absolute;
  margin-top: -1.8rem;
  margin-right: -1.8rem;
  background: ${({ theme }) => `rgb(${theme.primary.base})`};
  width: 17px;
  height: 17px;
  max-width: 17px;
  max-height: 17px;
  border-radius: 50%;
  display: flex;
  align-items: center !important;
  justify-content: center !important;

  span {
    color: ${({ theme }) => `rgb(${theme.background.high})`};
    padding: 0.2rem;
    font-size: 0.625rem;
    font-weight: 700;
    margin: 0;
    padding: 0;
  }
`
